import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Icon } from '@livable/saas-react-components';
import { Button, Menu } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import { useStore } from 'src/stores';
import useStyles from './styles';
const FormerResidentMenu = observer(props => {
  const classes = useStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const disabled = props.disabled,
    isFinalStatementEstimationEnabled = props.isFinalStatementEstimationEnabled,
    row = props.row,
    propertyIdExt = props.propertyIdExt;
  const searchParams = new URLSearchParams(window.location.search);
  const propertyId = searchParams.get('id') || propertyIdExt;
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    anchorEl = _useState2[0],
    setAnchorEl = _useState2[1];
  const open = Boolean(anchorEl);

  // const enrollTenantTrigger = (
  //   <Button variant="menuAction">
  //     <Icon type="move-in" />
  //     {t('residencies_page.enroll_resident_again')}
  //   </Button>
  // );

  const handleClick = event => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const handleFSEClick = () => {
    store.fse.setFSEBillModalData({
      accountId: row.accountId,
      residentName: row.fullname,
      residencyId: row.residencyId,
      unitName: row.unitName
    });
    store.fse.setFSEBillGeneralModalIsOpen(true);
    setAnchorEl(null);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    "aria-controls": "action-menu",
    "aria-expanded": open ? 'true' : undefined,
    "aria-haspopup": "true",
    "aria-label": "resident menu",
    className: classes.formerTodoDropdown,
    disabled: disabled,
    id: "action-menu-trigger",
    onClick: handleClick,
    state: open ? 'active' : undefined,
    variant: "actionButton",
    'custom-attribute': '822-residents-page-FormerResidentMenu'
  }, /*#__PURE__*/React.createElement("span", null, t('general.to_do')), /*#__PURE__*/React.createElement(Icon, {
    type: "triangle-down"
  })), /*#__PURE__*/React.createElement(Menu, {
    type: "action-menu",
    id: "action-menu",
    MenuListProps: {
      'aria-labelledby': 'action-menu-trigger'
    },
    anchorEl: anchorEl,
    open: open,
    onClose: handleClose,
    elevation: 0,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    target: "_blank",
    component: RouterLink,
    to: "/resident_acount?id=".concat(row.residencyId, "&accountId=").concat(row.accountId, "&propertyId=").concat(propertyId),
    variant: "menuAction",
    'custom-attribute': '823-residents-page-FormerResidentMenu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "account-box"
  }), t('residencies_page.view_account_profile')), isFinalStatementEstimationEnabled ? /*#__PURE__*/React.createElement(Button, {
    className: classes.lightTrigger,
    onClick: handleFSEClick,
    variant: "menuAction",
    'custom-attribute': '824-residents-page-FormerResidentMenu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "flag"
  }), t('fse_page.view_final_estimation')) : null));
});
export default FormerResidentMenu;